/* FRAME homepage — accessible newsletter confirmation focus. */
(() => {
  'use strict';
  const focusNewsletterFeedback = () => {
    const target = document.querySelector('.frame-home-newsletter__feedback');
    if (target && window.location.search.includes('customer_posted=true')) target.focus();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusNewsletterFeedback);
  } else {
    focusNewsletterFeedback();
  }
})();
